export const ImagesToShowPreLoad = 100;

export const ColumnsNumber = 3;

export const PlaceholdersHeights = [300, 533];
